var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabs)?_c('vue-tabs',{on:{"tab-change":_vm.emitChange}},[_vm._l((_vm.tabs),function(item,i){return [_c('v-tab',{key:i,attrs:{"title":item.label}},[_vm._t(item.name,[_vm._v(_vm._s(item.content))])],2)]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }